import { Crud } from "@/api";
import { Loader } from "@mantine/core";
import { redirect, type LoaderFunctionArgs } from "react-router-dom";

// /c/<code> (2026-09-03): human-readable share link. Resolves the short code
// to the cart's checkout params and redirects to the normal checkout URL, so
// nothing about checkout itself changes. Extra query params (parentOrderNo)
// pass straight through. Unknown / retired codes land on the home page.
export async function shortLinkLoader({ params, request }: LoaderFunctionArgs) {
  const code = params.code || "";
  try {
    const { cartId, secret } = await Crud.carts.resolveShortCode(code);
    const incoming = new URL(request.url).searchParams;
    const next = new URLSearchParams({ cartId, secret });
    incoming.forEach((value, key) => {
      if (key !== "cartId" && key !== "secret") next.set(key, value);
    });
    return redirect(`/checkout?${next.toString()}`);
  } catch (error) {
    console.warn("[short-link] could not resolve", code, error);
    return redirect("/");
  }
}

export default function ShortLink() {
  return (
    <div className="flex justify-center py-20">
      <Loader color="teal" />
    </div>
  );
}
